<template>
  <v-container>
    <div id="headersDevolucaoClientes">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Cliente
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Vendedor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Valor da venda
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Valor de devolução
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  % de devolução
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in devolucaoClientes"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.vendedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.valor_venda }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.valor_devolucao }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="getColor(item.porcentagem)"
                >
                  {{ item.porcentagem }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          to="/somenteclientes/detalhe-cliente-devolucao"
          :style="styleObject"
          class="text-center"
        >
          <div
            id="linkDetalheClienteDevolucao"
            class="text-center"
          >
            <v-icon
              id="iconLinkClienteDevolucao"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/somentecliente3'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesExibicaoMelhores',
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersDevolucaoClientes: [
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', class: 'black--text title' },
        { text: 'Valor da venda', value: 'valor_venda', align: 'right', class: 'black--text title' },
        { text: 'Valor de devolução', value: 'valor_devolucao', align: 'right', class: 'black--text title' },
        { text: '% de devolução', value: 'porcentagem', align: 'right', class: 'black--text title' },
      ],
      devolucaoClientes: [],
      vendedores: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhaProducao: [],
      cidades: [],
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedores = vendedores
        this.area = area
        this.rede = rede
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidades = cidades

        this.showDadosDevolucaoClientes()
      },

      async showDadosDevolucaoClientes () {
        this.loading = true
        this.devolucaoClientes = []

        await Clientes.showClientesDevolucaoImpropriaMotivos(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades).then(resposta => {
          if (resposta.data.status) {
            this.devolucaoClientes = resposta.data.dadosDevolucaoClientes.map((item) => {
              var listaDevolucaoClientes = ({
                nome_cliente: item.nome_cliente,
                vendedor: item.vendedor,
                valor_venda: item.valor_venda ? item.valor_venda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-',
                valor_devolucao: item.valor_devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                porcentagem: item.porcentagem.toFixed(2).toString().replace('.', ',') + '%',
              })

              return listaDevolucaoClientes
            })
          } else if (resposta.data.msg === 'Não há dados de devolução no período selecionado') {
            this.devolucaoClientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      getColor (value) {
        var porcentagem = parseFloat(value.replace(',', '.'))

        if (porcentagem >= 100) {
          return 'color: red'
        } else {
          return 'color: green'
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersDevolucaoClientes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersDevolucaoClientes {
      max-width: 100%;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersDevolucaoClientes {
      max-width: 92%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #textoTabela {
    font-size: 0.75rem !important
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
